export default "__VITE_ASSET__KbA$TciL__"